import {Component, ChangeDetectionStrategy} from '@angular/core';
import {Dialog} from '../../../../../interfaces/dialog/dialog';
import {DialogParams} from '../../../../../interfaces/dialog/dialog-params';
import {AbstractWidget} from '../../../../../models/cms/widget/abstract-widget';
import {WidgetViewerComponent} from '../widget-viewer/widget-viewer.component';

@Component({
  imports: [
    WidgetViewerComponent,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './widget-preview-modal.component.html',
})
export class WidgetPreviewModalComponent implements Dialog {
  widget: AbstractWidget | null = null;

  onDialogInit(params: DialogParams): void {
    params.class = 'modal-lg';
    this.widget = params.data.widget;
  }
}
